const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

async function adminFetch(path, options = {}) {
  const token = localStorage.getItem('developmentexpress_token');
  if (!token) throw new Error('auth_required');
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

export async function fetchPendingMachineRegistrations(status = 'pending') {
  const params = new URLSearchParams();
  params.set('status', status);
  params.set('limit', '100');
  return adminFetch(`/api/admin/machine-registrations?${params.toString()}`);
}

export async function approveMachineRegistration(registrationId, body = {}) {
  return adminFetch(`/api/admin/machine-registrations/${registrationId}/approve`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function rejectMachineRegistration(registrationId, adminNote = '') {
  return adminFetch(`/api/admin/machine-registrations/${registrationId}/reject`, {
    method: 'POST',
    body: JSON.stringify({ adminNote }),
  });
}

export async function getMachineRegistrationDocumentUrl(registrationId, docType) {
  const result = await adminFetch(`/api/admin/machine-registrations/${registrationId}/documents/${docType}`);
  return result?.url || null;
}
